module.exports = __webpack_public_path__ + "img/wait.98b4ec7a.png";